import template from './box-input-simple.html';

export default angular.module('gm.wealth.common')
  .directive('gmwBoxInputSimple', gmwBoxInputSimple)
  .name;

function gmwBoxInputSimple() {
  'ngInject';

  const directive = {
    link,
    template,
    restrict: 'E',
    require: ['ngModel', '^^?form'],
    scope: {
      label: '@?',
      placeholder: '@?',
      type: '@?',
      description: '@?',
    },
    transclude: {
      inputRight: '?gmwBoxInputRight',
      metaLeft: '?gmwBoxInputMetaLeft',
      metaRight: '?gmwBoxInputMetaRight',
      metaText: '?gmwBoxInputMetaText',
    }
  };
  return directive;

  function link(scope, _element, attrs, ctrls, transclude) {
    scope.labelSpacer = Object.prototype.hasOwnProperty.call(attrs, 'labelSpacer');
    scope.isInputRight = transclude.isSlotFilled('inputRight');
    scope.isMetaLeft = transclude.isSlotFilled('metaLeft');

    const ngModel = ctrls[0];
    scope.ngModel = ngModel;
    scope.form = ctrls[1];
    scope.isMetaRight = transclude.isSlotFilled('metaRight');
    scope.isMetaText = transclude.isSlotFilled('metaText');

    scope.onBlur = () => {
      scope.active = false;
      ngModel.$setTouched();
    };
    scope.onFocus = () => {
      scope.active = true;
    };

    scope.model = {};
    scope.$watch('model.value', (value) => {
      ngModel.$setViewValue(value);
    });

    ngModel.$parsers.push((value) => {
      scope.model.value = value;
      return value;
    });

    ngModel.$formatters.push((value) => {
      scope.model.value = value;
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/box-input-simple/box-input-simple.js